export default {
  SET_VERTICALS(state, verticals) {
    state.verticals = verticals
  },
  REMOVE_VERTICAL(state, itemId) {
      const verticalIndex = state.verticals.datas.findIndex((u) => u.id == itemId)
      state.verticals.datas.splice(verticalIndex, 1)
  },
  SELECTED_VERTICAL(state,data){
    state.verticals.datas = []
    state.verticals.total = 1;
    state.verticals.per_page = 1;
    state.verticals.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
